import React, { Component } from 'react'
import Section from '../shared/Section'
import TrialBtn from '../shared/Trial'
import { extendBaseClass, extend } from '../../utils/classes'

export class CallToAction extends Component {
  baseClass = 'call-to-action__container'

  extend = extendBaseClass.bind(this)

  content = this.extend('content')

  extendContent = (childClass) => extend(this.content, childClass)

  render() {
    return (
      <Section>
        <div className={this.baseClass}>
          <div className={this.content}>
            <h3 className={this.extendContent('title')}>
              Start your 30 days free trials today!
            </h3>
            <p>
              We have provided 30 Days Money Back Guarantee in case of
              dissatisfaction with our product.
            </p>
          </div>
          <TrialBtn parentClass={this.baseClass} />
        </div>
      </Section>
    )
  }
}

export default CallToAction
